import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { getYesOrNoOptions } from "Components/Form/RadioButton/radioButtonUtils";
import { useTexts } from "Components/TextContext";
import { CAR_FIND_STEP } from "Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car";
import { CarProductIntroFormValues } from "Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/ProductIntro/FormElements/interfaces";
import { CarPriceFormValues } from "Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/ProductPrice/interfaces";
import { showIsCarTrimmed } from "Features/CheckPrice/Products/RiskProducts/VehicleProducts/Car/helpers";
import { useCompletedFormState } from "Store/priceCalculation/priceCalculationHooks";
import { useUserIdentificationSelector } from "Store/userIdentification/userIdentificationSelectors";
import { getError } from "Utils/productUtils";
import { useFormikContext } from "formik";
import { default as React } from "react";

export const IsCarTrimmedField = (): React.ReactElement | null => {
  const formProps = useFormikContext<CarPriceFormValues>();
  const { getText } = useTexts();
  const userIdentification = useUserIdentificationSelector();
  const introFormValues = useCompletedFormState<CarProductIntroFormValues>(
    CAR_FIND_STEP.id,
  );

  const isHighRiskCar = showIsCarTrimmed(
    introFormValues.brand,
    introFormValues.year,
    userIdentification,
    formProps.values.usedByYoungerDriver,
  );

  if (!isHighRiskCar) {
    return null;
  }

  return (
    <RadioButtonTrueFalse
      name="isCarTrimmed"
      id="isCarTrimmed"
      label={getText("carform.label.iscartrimmed")}
      options={getYesOrNoOptions("isCarTrimmed-yes", "isCarTrimmed-no")}
      error={getError("isCarTrimmed", formProps)}
      direction="vertical"
    />
  );
};
